import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AppLayout from "./ui/AppLayout";
import Landing from "./pages/Landing";
import Chat from "./pages/Chat";
import About from "./pages/About";
import GlobalStyles from "./styles/GlobalStyles";
import PageNotFound from "./pages/PageNotFound";
import { DarkModeProvider } from "./context/DarkModeContext";
import { ChatProvider } from "./context/ChatContext";
import { Toaster } from "react-hot-toast";

const App = () => {
  return (
    <DarkModeProvider>
      <GlobalStyles />
      <BrowserRouter>
        <Routes>
          <Route
            element={
              <ChatProvider>
                <AppLayout />
              </ChatProvider>
            }
          >
            <Route index element={<Landing />} />
            <Route path="/chat" element={<Chat />} />
            <Route path="/about" element={<About />} />
          </Route>

          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </BrowserRouter>

      <Toaster
        position="top-center"
        gutter={12}
        containerStyle={{ marginTop: "16px" }}
        toastOptions={{
          success: {
            duration: 3000,
          },
          style: {
            fontSize: 16,
            padding: '16px 24px',
            backgroundColor: "var(--color-background)",
            color: "var(--chat-color)",
          }
        }}
      />
    </DarkModeProvider>
  );
};

export default App;
